"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrequentlyAskedQuestion = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const uuid_1 = require("uuid");
const FrequentlyAskedQuestionMetadata_1 = require("./FrequentlyAskedQuestionMetadata");
const LocalizedField_1 = require("./LocalizedField");
let FrequentlyAskedQuestion = class FrequentlyAskedQuestion {
    _id = (0, uuid_1.v4)();
    question;
    answer;
    order;
    humanReadableAnchor = "";
    category = "";
    machineName;
    isPublished;
    type;
    metadata;
    answerLocalized = new LocalizedField_1.LocalizedField();
    questionLocalized = new LocalizedField_1.LocalizedField();
    categoryLocalized = new LocalizedField_1.LocalizedField();
};
exports.FrequentlyAskedQuestion = FrequentlyAskedQuestion;
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], FrequentlyAskedQuestion.prototype, "_id", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], FrequentlyAskedQuestion.prototype, "question", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], FrequentlyAskedQuestion.prototype, "answer", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], FrequentlyAskedQuestion.prototype, "order", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], FrequentlyAskedQuestion.prototype, "humanReadableAnchor", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], FrequentlyAskedQuestion.prototype, "category", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], FrequentlyAskedQuestion.prototype, "machineName", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], FrequentlyAskedQuestion.prototype, "isPublished", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => legacy_enums_1.FrequentlyAskedQuestionType, { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.FrequentlyAskedQuestionType),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], FrequentlyAskedQuestion.prototype, "type", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => FrequentlyAskedQuestionMetadata_1.FrequentlyAskedQuestionMetadata, { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", FrequentlyAskedQuestionMetadata_1.FrequentlyAskedQuestionMetadata)
], FrequentlyAskedQuestion.prototype, "metadata", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => LocalizedField_1.LocalizedField, { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => LocalizedField_1.LocalizedField),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocalizedField_1.LocalizedField)
], FrequentlyAskedQuestion.prototype, "answerLocalized", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => LocalizedField_1.LocalizedField, { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => LocalizedField_1.LocalizedField),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocalizedField_1.LocalizedField)
], FrequentlyAskedQuestion.prototype, "questionLocalized", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => LocalizedField_1.LocalizedField, { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => LocalizedField_1.LocalizedField),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocalizedField_1.LocalizedField)
], FrequentlyAskedQuestion.prototype, "categoryLocalized", void 0);
exports.FrequentlyAskedQuestion = FrequentlyAskedQuestion = __decorate([
    (0, type_graphql_1.ObjectType)("FrequentlyAskedQuestion"),
    (0, typeorm_1.Entity)("frequentlyAskedQuestions")
], FrequentlyAskedQuestion);
//# sourceMappingURL=FrequentlyAskedQuestion.js.map